import SaleBookDetailView from '@features/myWriting/pages/MyWritingPage/components/SaleSummary/components/SummarySaleDetail/components/SaleBookDetail/SaleBookDetail'
import withSaleBookDetail from '@features/myWriting/pages/MyWritingPage/components/SaleSummary/components/SummarySaleDetail/components/SaleBookDetail/withSaleBookDetail'

const SaleBookDetail = withSaleBookDetail(SaleBookDetailView)

export default SaleBookDetail
